<template>
    <vx-expandable-card>
        <template v-slot:header>Documentation</template>
        <template v-slot:content>
            <div class="mb-6">
                Click <strong>Connect</strong> above to generate your Amplitude credentials — a <strong>Key</strong> and
                <strong>Secret</strong> will be displayed. You'll need these to set up Cohort Sync and Event Streaming
                in Amplitude.
            </div>

            <div class="mb-2 font-semibold">Cohort Sync</div>
            <ol class="list-decimal list-inside mb-6 space-y-1">
                <li>
                    In Amplitude, go to <strong>Data → Destinations</strong>, add Voxie, and paste your Key and Secret.
                </li>
                <li>
                    Open any cohort in Amplitude, click <strong>Sync</strong>, select the Voxie destination, and choose
                    which user properties to include.
                </li>
            </ol>

            <div class="mb-2 font-semibold">Event Streaming</div>
            <ol class="list-decimal list-inside mb-4 space-y-1">
                <li>
                    In Amplitude, go to <strong>Data → Destinations</strong>, add Voxie, and paste your Key and Secret.
                </li>
                <li>Enable the <strong>Send Users</strong> toggle to forward Identify calls to Voxie.</li>
                <li>
                    Optionally enable <strong>Send Events</strong> and filter to the specific event types you want to
                    forward.
                </li>
            </ol>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxExpandableCard } from '@voxie/frontend-components';
</script>
